/**
 * @file index.js — Point d'entrée de l'application.
 * Monte le composant React racine dans le DOM avec StrictMode activé.
 * Le ThemeProvider (next-themes) gère le mode clair/sombre via la classe CSS
 * sur l'élément <html>, synchronisé avec localStorage (clé « ringo-theme »).
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import 'leaflet/dist/leaflet.css';
import './i18n';
import './index.css';
import App from './App';

/**
 * Crée une racine en mode concurrent et effectue le rendu dans StrictMode
 * pour les avertissements de développement.
 * ThemeProvider injecte la classe « dark » sur <html> lorsque le thème sombre
 * est sélectionné, ce qui active les CSS custom properties définies dans index.css.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" storageKey="ringo-theme">
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
